const premadeColorsData = [
  {
    id: 7,
    name: "Polished Canvas",
    header_gradient: { id: 36, first_color: "#ffffff", second_color: "#d8d5d5", direction: 6 },
    body_gradient: { id: 36, first_color: "#ffffff", second_color: "#d8d5d5", direction: 6 },
    header_color: "#d8d5d5",
    body_color: "#ffffff",
    background_color: "#ffffff",
    title_color: "#000000",
    description_color: "#3f3b3b",
    button_color: "#d8d5d5",
    button_text_color: "#000000",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 9,
    name: "Galactic Shimmer",
    header_gradient: { id: 4, first_color: "#c1d7d2", second_color: "#00ff9d", direction: 6 },
    body_gradient: { id: 4, first_color: "#c1d7d2", second_color: "#00ff9d", direction: 6 },
    header_color: "#1ec2a1",
    body_color: "#c1d7d2",
    background_color: "#d1e6e2",
    title_color: "#ffffff",
    description_color: "#000000",
    button_color: "#1ec2a1",
    button_text_color: "#064c3e",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 10,
    name: "Platinum Shadow",
    header_gradient: { id: 35, first_color: "#828282", second_color: "#000000", direction: 6 },
    body_gradient: { id: 2, first_color: "#29dba6", second_color: "#30bb7f", direction: 2 },
    header_color: "#000000",
    body_color: "#828282",
    background_color: "#8f8f8f",
    title_color: "#fffafa",
    description_color: "#ffffff",
    button_color: "#000000",
    button_text_color: "#fffafa",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 11,
    name: "Celestial Blues",
    header_gradient: { id: 34, first_color: "#617ec2", second_color: "#0e2d77", direction: 6 },
    body_gradient: { id: 1, first_color: "#64c3e3", second_color: "#1960d2", direction: 2 },
    header_color: "#0e2d77",
    body_color: "#617ec2",
    background_color: "#99abd6",
    title_color: "#eca400",
    description_color: "#ffffff",
    button_color: "#0e2d77",
    button_text_color: "#ffffff",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 12,
    name: "Midnight Blush",
    header_gradient: { id: 5, first_color: "#ff6666", second_color: "#0a2463", direction: 6 },
    body_gradient: { id: 5, first_color: "#ff6666", second_color: "#0a2463", direction: 6 },
    header_color: "#ff6666",
    body_color: "#ff6666",
    background_color: "#f8c6a5",
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#0a2463",
    button_text_color: "#ffffff",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 13,
    name: "Amethyst Dreams",
    header_gradient: { id: 32, first_color: "#000a60", second_color: "#b40bbe", direction: 6 },
    body_gradient: { id: 32, first_color: "#000a60", second_color: "#b40bbe", direction: 6 },
    header_color: "#c156cc",
    body_color: "#000a60",
    background_color: "#8b91c1",
    title_color: "#ffffff",
    description_color: "#fffafa",
    button_color: "#b40bbe",
    button_text_color: "#ffffff",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 14,
    name: "Sweet Bubblegum",
    header_gradient: { id: 33, first_color: "#c156cc", second_color: "#3f57bc", direction: 6 },
    body_gradient: { id: 33, first_color: "#c156cc", second_color: "#3f57bc", direction: 6 },
    header_color: "#3f57bc",
    body_color: "#c156cc",
    background_color: "#d0b6d3",
    title_color: "#ffe966",
    description_color: "#ffffff",
    button_color: "#ffe966",
    button_text_color: "#000a60",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 15,
    name: "Tequila Sunrise",
    header_gradient: { id: 38, first_color: "#960200", second_color: "#ffd166", direction: 6 },
    body_gradient: { id: 38, first_color: "#960200", second_color: "#ffd166", direction: 6 },
    header_color: "#960200",
    body_color: "#960200",
    background_color: "#ffd885",
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#ffd166",
    button_text_color: "#ffffff",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 16,
    name: "Mystical Forest",
    header_gradient: { id: 40, first_color: "#00241b", second_color: "#419d78", direction: 6 },
    body_gradient: { id: 40, first_color: "#00241b", second_color: "#419d78", direction: 6 },
    header_color: "#419d78",
    body_color: "#00241b",
    background_color: "#97c9b6",
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#419d78",
    button_text_color: "#ffffff",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
  {
    id: 17,
    name: "Almond Mocha",
    header_gradient: { id: 41, first_color: "#e0d0c1", second_color: "#582707", direction: 6 },
    body_gradient: { id: 41, first_color: "#e0d0c1", second_color: "#582707", direction: 6 },
    header_color: "#000000",
    body_color: "#e0d0c1",
    background_color: "#eee5dd",
    title_color: "#ffffff",
    description_color: "#000000",
    button_color: "#8f6d56",
    button_text_color: "#000000",
    header_color_scheme: 2,
    body_color_scheme: 1,
  },
];

export default premadeColorsData;
